import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 1000 618"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#ff5f00",
      d: "M365 66h270v486H365z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#eb001b",
      d: "M382 309c0-99 46-186 118-243a309 309 0 1 0 0 486 309 309 0 0 1-118-243z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#f79e1b",
      d: "M1000 309a309 309 0 0 1-500 243 309 309 0 0 0 0-486 309 309 0 0 1 500 243z"
    }, null, -1)
  ])))
}
export default { render: render }